var React = require('react');

function IcNavLounge (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 2H4v5.5C4 10.5376 6.46243 13 9.5 13c3.0376 0 5.5-2.4624 5.5-5.5V2zM4 0H2v7.5C2 11.6421 5.35786 15 9.5 15c4.1421 0 7.5-3.3579 7.5-7.5V0H4zm17 0h-2v7h2V0zm-2 19v-2H0v2h19z","fill":"currentColor"}));
}

IcNavLounge.defaultProps = {"fill":"none","viewBox":"0 0 21 19"};

module.exports = IcNavLounge;

IcNavLounge.default = IcNavLounge;
